import * as THREE from "three"
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls"
import { gsap } from "gsap";
import * as SHT from "spherical-harmonic-transform";

import "./css/main.css";
import "./css/custom.css";

import Typed from 'typed.js';
import 'particles.js';
import { Vector3 } from "three";

particlesJS.load('particles-js', 'assets/particles.json', function() {});

const strings = ['Deep Learning', 'Computer Vision', 'Data Visualization', 'Autonomous Systems', 'Reinforcement Learning', 'Computational Biology', 'Open Source Software']

const options = {
  strings,
  smartBackspace: true,
  typeSpeed: 20,
  backSpeed: 0,
  loop: true,
}

const typed = new Typed(".text-wrapper", options);



function sphericalToCartesian(azi, elev, r) {
  elev = Math.PI / 2 - elev
  return new THREE.Vector3(
    Math.sin(elev) * Math.cos(azi) * r,
    Math.sin(elev) * Math.sin(azi) * r,
    Math.cos(elev) * r
  )
}

function addHarmonics() {
  let grid = []
  let grid_da = []
  let grid_de = []
  let uvs = []
  let indices = []
  const eps = Math.PI / 1000

  for (let i = 0; i < RESOLUTION * 2; i++) {
    for (let j = 0; j <= RESOLUTION; j++) {
      const azi = i / RESOLUTION * Math.PI
      const elev = Math.PI / 2 - j / RESOLUTION * Math.PI
      grid.push([azi, elev])
      if (j == 0) {
        grid_da.push([azi + eps, elev - eps])
        grid_de.push([azi - eps, elev - eps])
      } else {
        grid_da.push([azi - eps, elev + eps])
        grid_de.push([azi + eps, elev + eps])
      }
      uvs.push(azi / (2 * Math.PI), elev / Math.PI)
    }
  }

  for (let i = 0; i < RESOLUTION * 2; i++) {
    for (let j = 0; j < RESOLUTION; j++) {
      const a = i * (RESOLUTION + 1) + j
      const b = i * (RESOLUTION + 1) + j + 1
      const c = ((i + 1) % (RESOLUTION * 2)) * (RESOLUTION + 1) + j + 1
      const d = ((i + 1) % (RESOLUTION * 2)) * (RESOLUTION + 1) + j

      indices.push(a, b, d)
      indices.push(b, c, d)
    }
  }

  const shs = SHT.computeRealSH(MAX_L, grid)
  const shs_de = SHT.computeRealSH(MAX_L, grid_de)
  const shs_da = SHT.computeRealSH(MAX_L, grid_da)
  let pu = new THREE.Vector3()
  let pv = new THREE.Vector3()
  let normal = new THREE.Vector3()

  let geometries = []
  let m = 0
  for (let l = 0; l <= MAX_L; l++) {
    for (let mm = 0; mm < 2 * l + 1; mm++) {
      let vertices = []
      let normals = []
      let colors = []
      for (let i = 0; i < grid.length; i++) {
        let pos = sphericalToCartesian(grid[i][0], grid[i][1], Math.abs(shs[m][i]))
        let pos_de = sphericalToCartesian(grid_de[i][0], grid_de[i][1], Math.abs(shs_de[m][i]))
        let pos_da = sphericalToCartesian(grid_da[i][0], grid_da[i][1], Math.abs(shs_da[m][i]))
        vertices.push(pos.x, pos.y, pos.z)
        if (shs[m][i] > 0.0001)
          colors.push(0xAC / 0xFF, 0xEE / 0xFF, 0xF3 / 0xFF)
        else if (shs[m][i] < -0.0001)
          colors.push(0xFF / 0xFF, 0x70 / 0xFF, 0x77 / 0xFF)
        else
          colors.push(0.0, 0.0, 0.0)
        pu.subVectors(pos, pos_de)
        pv.subVectors(pos, pos_da)
        normal.crossVectors(pu, pv).normalize()
        normals.push(normal.x, normal.y, normal.z)
      }

      const geometry = new THREE.BufferGeometry()
      geometry.setIndex(indices)
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
      geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3))
      geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3))
      geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2))

      const pos = getHarmonicsPos(l, mm - l)
      geometry.rotateX(Math.PI / 2)
      geometry.translate(pos.x, pos.y, pos.z)
      geometry.userData = {l: l, m: mm - l}
      geometries.push(geometry)
      m++
    }
  }

  //const geom = BufferGeometryUtils.mergeBufferGeometries(geometries, true)
  const group = new THREE.Group()
  for (let geom of geometries) {
  let mesh = new THREE.Mesh(geom, material)
  group.add(mesh)
  }
  group.castShadow = true
  group.receiveShadow = true
  scene.add(group)
  return geometries
}

function getHarmonicsPos(l, m) {
  let x = m * SEP_X
  let y = - l * SEP_Y - l + 1
  return new THREE.Vector3(x, y, 0)
}



const MAX_L = 4
const RESOLUTION = 128
const SEP_X = 6
const SEP_Y = 6
const INITIAL_Z = 20

const material = new THREE.MeshStandardMaterial({ flatShading: false, vertexColors: THREE.VertexColors })
const material_selected = new THREE.MeshStandardMaterial({ flatShading: false, vertexColors: THREE.VertexColors, wireframe: true, emissive: 0x222222 })

let focused = {
  l: 1,
  m: 0  
}
let canvas = document.getElementById('shs-canvas')


//const gui = new dat.GUI({width: 600})
const scene = new THREE.Scene()
//scene.background = new THREE.Color(0xFFFFFF)
const camera = new THREE.PerspectiveCamera(50, canvas.offsetWidth / canvas.offsetHeight, 0.01, 150)

const light = new THREE.AmbientLight(0x404040, 0.75)
scene.add(light)

function addLight(x, y, z) {
  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
  directionalLight.position.set(x, y, z)
  directionalLight.castShadow = true
  directionalLight.shadow.mapSize.width = 1024
  directionalLight.shadow.mapSize.height = 1024
  directionalLight.shadow.camera.near = 0.5
  directionalLight.shadow.camera.far = 10
  directionalLight.shadow.camera.left = -10
  directionalLight.shadow.camera.right = 10
  directionalLight.shadow.camera.bottom = -20
  directionalLight.shadow.camera.top = 0
  
  scene.add(directionalLight)
  scene.add(directionalLight.target)
}

addLight(0.5, 0.5, 0.5)
addLight(-0.5, 0.5, 0.5)

camera.position.z = INITIAL_Z
camera.position.y = - SEP_Y
camera.lookAt(0, - SEP_Y, 0)
camera.updateProjectionMatrix()

//gui.add(light, 'intensity', 0, 10, 0.001)

const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: "high-performance", precision: "highp"})
renderer.setSize(canvas.offsetWidth, canvas.offsetHeight)
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.shadowMap.autoUpdate = false
renderer.shadowMap.needsUpdate = true
//document.body.appendChild(renderer.domElement)


const controls = new OrbitControls(camera, renderer.domElement)
controls.enableDamping = true
controls.enablePan = false
//controls.enableRotate = false
controls.minDistance = 0.5
controls.maxDistance = 50
controls.target.set(0, -SEP_Y, 0)
controls.autoRotate = true
controls.autoRotateSpeed = 1.0
controls.update()


function animate() {
  camera.updateMatrix()
  controls.update()
	renderer.render(scene, camera)
  requestAnimationFrame(animate)

  let v = camera.position.clone()
  v.sub(controls.target)
  v.y = 0.0
  let angle = v.angleTo(new THREE.Vector3(0, 0, 1))
  controls.autoRotateSpeed = angle * angle + 1
}


canvas.addEventListener('keydown', (e) => {
  switch (e.key) {
    case 'ArrowLeft':
      if (focused.m > - focused.l)
        focused.m -= 1
      break;
    case 'ArrowRight':
      if (focused.m < focused.l)
        focused.m += 1
      break;
    case 'ArrowUp':
      if (focused.l > 0 && Math.abs(focused.m) < focused.l)
        focused.l -= 1
      break;
    case 'ArrowDown':
      if (focused.l < MAX_L)
        focused.l += 1
      break;
    default:
      return;
  }
  let newTarget = getHarmonicsPos(focused.l, focused.m)
  gsap.to(controls.target, {x: newTarget.x, y: newTarget.y, z: newTarget.z, duration: 1, ease: "power4"}).play()
  gsap.to(camera.position, {x: newTarget.x, y: newTarget.y, z: INITIAL_Z, duration: 1, ease: "power4"}).play()
  e.stopPropagation();
});



addHarmonics()


let selectedObject = null
let raycaster = new THREE.Raycaster()
let mousemoved = false
canvas.addEventListener("mousemove", event => {
  mousemoved = true
  let rect = event.target.getBoundingClientRect()
  let mouse = new THREE.Vector2(((event.clientX - rect.left) / canvas.offsetWidth) * 2 - 1, -((event.clientY - rect.top) / canvas.offsetHeight) * 2 + 1)
  raycaster.setFromCamera(mouse, camera)
  var intersects = raycaster.intersectObjects(scene.children, true)
  if (intersects.length > 0) {
    if (selectedObject !== intersects[0].object)
    if (selectedObject) {
    selectedObject.material = material
    selectedObject.material.needsUpdate = true
    }
    selectedObject = intersects[0].object
    selectedObject.material = material_selected
    selectedObject.material.needsUpdate = true
 } else if (selectedObject) {
  selectedObject.material = material
  selectedObject.material.needsUpdate = true
  selectedObject = null
 }
})


canvas.addEventListener("mousedown", event => {mousemoved = false;})
canvas.addEventListener("mouseup", event => {
  if (mousemoved)
    return
  let rect = event.target.getBoundingClientRect()
  let mouse = new THREE.Vector2(((event.clientX - rect.left) / canvas.offsetWidth) * 2 - 1, -((event.clientY - rect.top) / canvas.offsetHeight) * 2 + 1)
  raycaster.setFromCamera(mouse, camera);
  var intersects = raycaster.intersectObjects(scene.children, true)
  if (intersects.length > 0) {
    focused = intersects[0].object.geometry.userData
    let newTarget = getHarmonicsPos(focused.l, focused.m)
    gsap.to(controls.target, {x: newTarget.x, y: newTarget.y, z: newTarget.z, duration: 1, ease: "power4"}).play()
    gsap.to(camera.position, {x: newTarget.x, y: newTarget.y, z: INITIAL_Z, duration: 1, ease: "power4"}).play()
    controls.autoRotate = false
 }
})

animate()


